import PropTypes from "prop-types";
// @mui
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
} from "@mui/material";
import Iconify from "../iconify";

// ----------------------------------------------------------------------

EditDialog.propTypes = {
  open: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onClose: PropTypes.func,
  onCloseButton: PropTypes.func,
  title: PropTypes.string,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  folderName: PropTypes.string,
  onChangeFolderName: PropTypes.func,
  tripId: PropTypes.string,
  row: PropTypes.array,
  children: PropTypes.node,
  maxWidth: PropTypes.string,
  showClose: PropTypes.bool,
};

export default function EditDialog({
  title,
  row,
  open,
  onClose,
  //
  onCreate,
  onUpdate,
  tripId,
  //
  folderName,
  onChangeFolderName,
  children,
  maxWidth = "md",
  fullWidth = true,
  showClose = false,
  onCloseButton,
  ...other
}) {
  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      {...other}
      sx={{
        zIndex: 99,
      }}
    >
      <Stack flexDirection={"row"} justifyContent={"space-between"}>
        <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3) }}>
          {" "}
          {title}{" "}
        </DialogTitle>
        {showClose && (
          <Button onClick={onCloseButton}>
            <Iconify icon="flowbite:close-outline" />
          </Button>
        )}
      </Stack>

      <Divider />

      <DialogContent dividers sx={{ pt: 1, pb: 3, border: "none" }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}
